import {
  INotificationRepository,
  NotificationImpl,
} from "api/merchantRepository/notification/NotificationRepository";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";
import { NotificationViewModel } from "../viewModel/NotificationViewModel";

export class NotificationInjection extends InjectionModule {
  private static readonly notificationRepositoryToken = Symbol(
    "INotificationRepository",
  );
  private static readonly notificationViewModelToken = Symbol(
    "NotificationViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.notificationRepositoryToken,
      useClass: NotificationImpl,
    },
    {
      scope: "viewModel",
      token: this.notificationViewModelToken,
      useClass: NotificationViewModel,
    },
  ];

  static getRepo(): INotificationRepository {
    return this.resolve(this.notificationRepositoryToken);
  }
}
